<template>
  <v-dialog :value="value" @input="close()" max-width="560" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card elevation="1">
      <v-card-title class="height-57">
        <span>{{ use_language.reject_order_request }} {{ requestNo }}</span>
        <v-spacer/>
        <v-btn icon @click="close()"><v-icon color="danger">mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-form ref="rejectForm" lazy-validation>
          <!-- ไม่อนุมัติต้องระบุเหตุผลเสมอ คำขอจะกลับไปที่ผู้สร้าง -->
          <div class="pb-2">{{ use_language.reject_reason }} :</div>
          <v-textarea v-model="reason" :rules="rules" rows="3" outlined dense autofocus></v-textarea>
          <div style="font-size: 12px; color: #9e9e9e;">{{ use_language.reject_hint }}</div>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn :elevation="1" outlined class="px-2" @click="close()">{{ use_language.close }}</v-btn>
        <v-btn :elevation="1" color="red" dark class="px-2" :loading="loading" @click="Submit()">
          <v-icon size="20" class="mr-1">mdi-close-circle-outline</v-icon>
          {{ use_language.action_REJECT }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { getOmsLanguage } from '@/website/backend/oms/oms_language'
  import { rejectOrderRequest } from '@/website/backend/oms/oms_service'

  export default {
    props: {
      value: { type: Boolean, default: false },
      tempId: { type: Number, default: 0 },
      requestNo: { type: String, default: '' }
    },
    data: () => ({
      use_language: getOmsLanguage(),
      loading: false,
      reason: null,
      rules: []
    }),
    watch: {
      value (isOpen) {
        if (isOpen) {
          this.reason = null
          this.rules = []
        }
      }
    },
    methods: {
      close () {
        this.$emit('input', false)
      },
      async Submit () {
        this.rules = [v => (!!v && v.trim() != '') || this.use_language.please_specify]
        await this.$nextTick()
        if (!this.$refs.rejectForm.validate()) {
          return
        }
        this.loading = true
        const response = await rejectOrderRequest(this.tempId, this.reason)
        this.loading = false
        if (response.status != 'success') {
          this.$swal({
            position: 'top',
            type: 'error',
            text: response.message || (response.errorCode == 'NETWORK' ? this.use_language.network_error : this.use_language.cannot_perform_operation)
          })
          // สถานะอาจถูกเปลี่ยนไปแล้ว ให้หน้าที่เปิด dialog โหลดใหม่
          this.$emit('done', false)
          this.close()
          return
        }
        this.$emit('done', true)
        this.close()
      }
    }
  }
</script>
